import type { AppSettings } from './interfaces';

import { setAppSettings } from './appSettings';

export function initSettingsFromDomData(): Partial<AppSettings> {
  if (typeof window !== 'undefined') {
    return setAppSettings(
      // eslint-disable-next-line no-underscore-dangle
      window?.__NEXT_DATA__?.props?.pageProps?.appSettings || {}
    );
  }

  return {};
}
